import cx from 'classnames';
import { defineMessages, useIntl } from 'react-intl';

import config from '@plone/registry';

import {
  isNews,
  isTestimonial,
} from '@redturtle/qubicaamf-theme/components/View/NewsTestimonialsView/NewsTestimonialView';
import styles from './styles.module.css';
import type { MasonryItemProps } from './MasonryTemplate';
import CTA from '@redturtle/qubicaamf-theme/components/Blocks/commons/CTA';

const MasonryCard = ({ data }: { data: MasonryItemProps }) => {
  const intl = useIntl();

  const Image = config.getComponent('Image').component;

  const imageField = data.image_scales?.alternative_preview_image
    ? 'alternative_preview_image'
    : 'preview_image';
  const hasImage =
    !!data.image_scales?.alternative_preview_image ||
    !!data.image_scales?.preview_image;

  return (
    <div className={styles.masonryCard}>
      {hasImage && (
        <div className={styles.imageContainer}>
          <Image
            item={data}
            imageField={imageField}
            className={styles.cardImage}
            alt={data.preview_caption ?? ''}
          />
          {data['@type'] === 'Testimonial' && data.image_scales.icon && (
            <div className={styles.testimonialIconContainer}>
              <Image
                item={data}
                imageField="icon"
                className={styles.testimonialIcon}
                alt={''}
              />
            </div>
          )}
        </div>
      )}
      <div
        className={cx(styles.textContainer, {
          [styles.higherPadding]:
            data['@type'] === 'Testimonial' &&
            data.image_scales.icon &&
            data.image_scales.preview_image,
        })}
      >
        {(data.news_macro_type_info || data.testimonials_macro_type_info) && (
          <div className={styles.subject}>
            {isNews(data)
              ? data.news_macro_type_info?.title
              : data.testimonials_macro_type_info?.title}
          </div>
        )}

        <div>
          <h3 className={styles.cardTitle}>{data.title}</h3>
        </div>
        {data.description && (
          <div className={styles.cardDescription}>
            {isTestimonial(data) ? `"${data.description}"` : data.description}
          </div>
        )}
        <div className={styles.ctaContainer}>
          <CTA
            ctaButtonStyle="simple"
            cta_color="black"
            href={data['@id']}
            openLinkInNewTab={false}
          >
            {intl.formatMessage(messages.read_more)}
          </CTA>
        </div>
      </div>
    </div>
  );
};

export default MasonryCard;

const messages = defineMessages({
  read_more: {
    id: 'read_more',
    defaultMessage: 'Read more',
  },
});
